import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../assets/styles/Header.css";
import clock from "../assets/images/clock.png";
import call_out from "../assets/images/call_out.png";
import country_fr from "../assets/images/country_fr.jpg";
import country_fr_2 from "../assets/images/country_fr.svg";
import country_gb from "../assets/images/country_gb.svg";
import call_out_in from "../assets/images/call_out_in.png";
import logo from "../assets/images/PL_logo_ohne_background_v003.png";
import map from "../assets/images/map.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {faGoogle} from "@fortawesome/free-brands-svg-icons";
import {headerButtons, handleMenuActive} from "../assets/js/swithalert"



function Header() {

  const [selectedFlag, setSelectedFlag] = useState(country_fr); // Default flag
  const [selectedFlag_2, setSelectedFlag_2] = useState(country_fr_2); // Default flag
  const { i18n, t } = useTranslation();
  const en = "en";
  const fr = "fr"

  const changeLanguage = (lng, flagSrc, flagSrc_2) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng); // Save the selected language
    setSelectedFlag(flagSrc);
    setSelectedFlag_2(flagSrc_2);
    window.location.reload();
  };

  useEffect(() => {
      headerButtons();
      handleMenuActive();
      const savedLanguage = localStorage.getItem("language") || "fr";
      i18n.changeLanguage(savedLanguage);
      setSelectedFlag(savedLanguage === "fr" ? country_fr : country_gb);
      setSelectedFlag_2(savedLanguage === "fr" ? country_fr_2 : country_gb);
  }, []);
  
  return (
    <div>
    <div class="topbar">
      <div class="container">
        <div class="row mx-3 desktop">
          <div class="col-md-9 col-sm-8 col-8">
            <div class="row">
              <div class="col-md-12">
                <div class="social-d me-10 d-inline-block">
                  <a href="tel:0033658919639" style={{ color: "#fff" }}>
                    <img src={call_out} alt="Call us" />
                    (0033) 06 58 91 96 39
                  </a>
                </div>
                <div class="social-d d-inline-block headerWorkingHours">
                  <a style={{ color: "#fff" }}>
                    <img src={clock} alt="Working hours" />
                    {t("working_hours")}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-4 col-4 text-lg-end text-center">
            <div class="social">
              <a
                href="https://www.facebook.com/pristanelaverie"
                target="_blank"
                class=""
                title="Link to Facebook"
              >
                <svg
                  viewBox="0,0,256,256"
                  width="31px"
                  height="31px"
                  fill-rule="nonzero"
                  class="fa-facebook"
                >
                  <g
                    fill-opacity="1"
                    fill="#00b050"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    style={{"mix-blend-mode": "normal"}}
                  >
                    <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
                  </g>
                  <g
                    fill="#ffffff"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="0"
                   
                    style={{"mix-blend-mode": "normal"}}
                  >
                    <g transform="scale(5.12,5.12)">
                      <path d="M25,2c-12.682,0 -23,10.317 -23,23c0,12.683 10.318,23 23,23c12.683,0 23,-10.317 23,-23c0,-12.683 -10.317,-23 -23,-23zM32,16h-3.29c-1.938,0 -2.71,0.455 -2.71,1.806v3.194h6l-1,5h-5v13h-6v-13h-3v-5h3v-2.774c0,-4.225 1.686,-7.226 6.581,-7.226c2.622,0 5.419,1 5.419,1z"></path>
                    </g>
                  </g>
                </svg>
              </a>
              <a
                href="https://www.google.com/pristanelaverie/"
                target="_blank"
                class=""
                title="Link to Google"
              >
                <i class="fa fa-google"></i>
                <FontAwesomeIcon icon={faGoogle}  className="fa-google" />
              </a>
              <a
                href="https://www.google.com/pristanelaverie/"
                target="_blank"
                class=""
                title="Link to call"
              >
                <img style={{"max-width": "65%"}} src={call_out_in} alt="Working hours" />
              </a>
            </div>
            <div class="country cs-country mx-0">
              <div class="dropdown-toggle-cs">
                <img src={selectedFlag} class="imgTranslation" alt="Translate page"/>
              </div>
              <ul class="dropdown-cs">
                <li onClick={() => changeLanguage(fr, country_fr, country_fr_2)}>
                  <img src={country_fr} alt="French"/>
                </li>
                <li onClick={() => changeLanguage(en, country_gb, country_gb)}>
                  <img src={country_gb} alt="English"/>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row mobile">
          <div class="col-md-12 text-end text-center">
            <div class="social">
              <a
                href="https://www.facebook.com/pristanelaverie"
                class="ms-1 me-1"
                target="_blank"
                title="Link to Facebook"
              >
                <i class="fa fa-facebook"></i>
              </a>
              <a
                href="https://www.google.com/pristanelaverie/"
                class="ms-1 me-1"
                target="_blank"
                title="Link to google"
              >
                <i class="fa fa-google"></i>
              </a>
              <a
                href="https://www.google.com/pristanelaverie/"
                class="ms-1 me-1"
                target="_blank"
                title="Link to google"
              >
                <i class="fal fa-phone"></i>
              </a>
            </div>
            <div class="country cs-country ms-1">
              <div class="dropdown-toggle-cs">
                <img
                  src={selectedFlag}
                  class="imgTranslation"
                  alt="Translate page"
                />
              </div>
              <ul class="dropdown-cs">
                <li onClick={() => changeLanguage(fr, country_fr, country_fr_2)}>
                  <img
                    src={country_fr}
                    alt="Frensh"
                  />
                </li>
                <li onClick={() => changeLanguage(en, country_gb, country_gb)}>
                  <img
                    src={country_gb}
                    alt="English"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middlebar">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-4 col-4 pt-sm-3 pt-3">
            <a class="navbar-brand d-block mx-auto" href="/"
              ><img
                src={logo}
                id="imgLogoTop"
                alt="PristaneLaverie logo"
                class="d-block mx-auto"
            /></a>
          </div>
          <div class="col-md-6 col-sm-4 col-4 pt-4">
            <div class="row">
              <div class="address d-flex justify-content-center align-items-center">
                <span class="d-flex justify-content-center align-items-center me-2"
                  ><img src={map} alt="icon"
                /></span>
                <p>
                  <a
                    data-type="distance"
                    href="#"
                    target="_blank"
                    class="text-white"
                  >
                    41 Rue du Chablais<br />
                    74100, Annemasse
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="hamburger col-sm-4 col-4 my-auto pt-sm-4 pt-4">
              <span class="bar"></span>
              <span class="bar"></span>
              <span class="bar"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="menubar">
      <div class="container flex-lg-row flex-nowrap align-items-center">
        <ul class="navbar-nav flex-row" data-smartmenus-id="17392572690903928">
            <li class="nav-item home active">
                <a class="nav-link" href="/" aria-haspopup="true" aria-expanded="false">{t("menubar_home")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/self-wash" aria-haspopup="true" aria-expanded="false">{t("menubar_wash")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/self-dry" aria-haspopup="true" aria-expanded="false">{t("menubar_dry")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/pricing/" aria-haspopup="true" aria-expanded="false">{t("menubar_pricing")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/contact" aria-haspopup="true" aria-expanded="false"> {t("menubar_contact")}</a>
            </li>
        </ul>
      </div>
    </div>
    <nav  class="side-navbar">
      <div class="my-5">
        <a class="navbar-brand d-block mx-auto" href="/wwww/pristane-laverie.com/"
        ><img src={logo} id="imgLogoTop" alt="PristaneLaverie logo" class="d-block mx-auto"
        /></a>
        <button type="button" class="btn-close" aria-label="Close"></button>
      </div>
      <div class="container">
        <ul class="navbar-nav">
            <li class="nav-item active home">
                <a class="nav-link" href="/" aria-haspopup="true" aria-expanded="false">{t("menubar_home")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/self-wash" aria-haspopup="true" aria-expanded="false">{t("menubar_wash")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/self-dry" aria-haspopup="true" aria-expanded="false">{t("menubar_dry")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/pricing/" aria-haspopup="true" aria-expanded="false">{t("menubar_pricing")}</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" href="/contact" aria-haspopup="true" aria-expanded="false"> {t("menubar_contact")}</a>
            </li>
        </ul>
      </div>
    </nav>
    <div class="country cs-country fixe-country-select">
        <div class="dropdown-toggle-cs">
          <img src={selectedFlag_2} class="imgTranslation" alt="Translate page"/>
          <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" class="arrow"><path d="M5.41 7.59L4 9l8 8 8-8-1.41-1.41L12 14.17"></path></svg>
        </div>
        <ul class="dropdown-cs">
          <li class="mb-1" onClick={() => changeLanguage(fr, country_fr, country_fr_2)}>
            <img src={country_fr_2} alt="French"/>
            
          </li>
          <li class="mt-2" onClick={() => changeLanguage(en, country_gb, country_gb)}>
            <img src={country_gb} alt="English"/>
          </li>
        </ul>
    </div>
  </div>
    
  );
}

export default Header;
